import { render, staticRenderFns } from "./oilGun.vue?vue&type=template&id=0a84ef74&scoped=true"
import script from "./oilGun.vue?vue&type=script&lang=js"
export * from "./oilGun.vue?vue&type=script&lang=js"
import style0 from "./oilGun.vue?vue&type=style&index=0&id=0a84ef74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a84ef74",
  null
  
)

export default component.exports